import { OnInitSuccess } from '@wix/checkout-components';
import { useCheckoutStore, CheckoutActions } from '../../../../providers';
import {
  PaymentCycle,
  currentProductCycle,
  PaymentCycle_BIMap,
} from '../../../../utils';
import { BiReporter, FedopsReporter, Product } from '../../../../types';

interface PaymentPageReadyBiEventLogOptions {
  productId: number;
  productGuid: string;
  eventAggregator: string;
  cycle: number | undefined;
  pricing: {
    fullPrice: number;
    priceAfterDiscount: number;
  };
  currency: string;
}

export interface UseOnInitSuccessOptions {
  currentProduct: Product;
  currentCycle: PaymentCycle;
  currencyCode: string;
  endCreateOrderPageHttpRequestInteraction: FedopsReporter;
  paymentPageReadyBiEventLog: BiReporter<PaymentPageReadyBiEventLogOptions>;
  endInitializeOrderPageInteraction: FedopsReporter;
}

export function useOnInitSuccess(
  options?: UseOnInitSuccessOptions,
): OnInitSuccess | undefined {
  const { dispatch } = useCheckoutStore();
  if (options) {
    return (orderPageEventAggregator?: string) => {
      const { currentProduct, currentCycle } = options;
      const productCycle = currentProductCycle(currentProduct, currentCycle);
      const newOrderPageEventAggregatorValue = orderPageEventAggregator ?? '';
      dispatch(
        CheckoutActions.setOrderPageEventAggregator(
          newOrderPageEventAggregatorValue,
        ),
      );
      options.endCreateOrderPageHttpRequestInteraction();
      options.paymentPageReadyBiEventLog({
        productId: options.currentProduct.id,
        productGuid: options.currentProduct.guid ?? '',
        eventAggregator: newOrderPageEventAggregatorValue,
        cycle: PaymentCycle_BIMap[options.currentCycle],
        pricing: {
          fullPrice:
            productCycle.fullTermDisplayPrice +
            productCycle.fullTermDisplaySavings,
          priceAfterDiscount: productCycle.fullTermDisplayPrice,
        },
        currency: options.currencyCode,
      });
      options.endInitializeOrderPageInteraction();
    };
  }

  return undefined;
}
